(() => {
  const root = document.documentElement;
  if (root.dataset.jupityrCartTouchGuard) return;
  root.dataset.jupityrCartTouchGuard = 'ready';

  const mobile = window.matchMedia('(max-width: 749px)');
  let lastX = 0;
  let lastY = 0;

  document.addEventListener('touchstart', (event) => {
    if (event.touches.length !== 1) return;
    lastX = event.touches[0].clientX;
    lastY = event.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!mobile.matches || event.touches.length !== 1) return;
    if (!(event.target instanceof Element)) return;
    const drawer = event.target.closest('cart-drawer.jupityr-cart.active');
    if (!drawer) return;

    const touch = event.touches[0];
    const dx = touch.clientX - lastX;
    const dy = touch.clientY - lastY;
    lastX = touch.clientX;
    lastY = touch.clientY;
    if (Math.abs(dx) > Math.abs(dy)) return;

    const items = event.target.closest('cart-drawer-items');
    if (items && drawer.contains(items)) {
      const remaining = items.scrollHeight - items.clientHeight - items.scrollTop;
      if ((dy < 0 && remaining > 1) || (dy > 0 && items.scrollTop > 1)) return;
    }

    if (event.cancelable) event.preventDefault();
  }, { passive: false });
})();
